import { Row, Col } from 'antd/index';
import CustomInfoCard from 'components/CustomInfoCard/CustomInfoCard';
import { useHistory } from 'react-router-dom';
import handleRedirect from 'utils/handleRedirect';
import { PATH_APP, NO_ACCESS } from 'constants/index';
import { useSelector } from 'react-redux';
import setCollectionDocument from 'utils/collectionDocumentCRUD/setCollectionDocument';
import { accessRequestsCollectionRef } from 'services/firestore/references';
import { showInfoMessage } from 'utils/showInfoMessage';
import getCollectionDocumentWithWhere from 'utils/collectionDocumentCRUD/getCollectionDocumentWithWhere';
import { useEffect, useState } from 'react';
import Loader from 'components/Loader/Loader';
import messages from 'utils/validationSchemaOptions/validationSchemaOptions';

const { somethingWentWrong } = messages;
const { LOGIN } = PATH_APP;
const { PENDING_REQUEST, ACCESS_DENIED, MADE_REQUEST, REQUEST_ACCESS } = NO_ACCESS;

const handleRequestAccess = async (email, history, setRequestAlreadyExists) => {
  try {
    const { id } = accessRequestsCollectionRef.doc();
    await setCollectionDocument(accessRequestsCollectionRef, { email, id }, id);
    setRequestAlreadyExists(prev => !prev);
  } catch (e) {
    showInfoMessage('error', somethingWentWrong);
    handleRedirect(history, LOGIN);
    console.log(e);
  }
};
const NoAccess = () => {
  const email = useSelector(state => state.auth.email);
  const [isLoading, setIsLoading] = useState(true);
  const [requestAlreadyExists, setRequestAlreadyExists] = useState(false);

  useEffect(() => {
    if (!email) {
      showInfoMessage('error', somethingWentWrong);
      handleRedirect(history, LOGIN);
      return;
    }
    const handleAsync = async () => {
      const request = await getCollectionDocumentWithWhere(accessRequestsCollectionRef, {
        fieldPath: 'email',
        opStr: '==',
        status: email,
      });
      setRequestAlreadyExists(request.length >= 1);
      setIsLoading(false);
    };

    handleAsync();
  }, []);

  const history = useHistory();
  return isLoading ? (
    <Loader />
  ) : (
    <Row className="login-screen">
      <Col md={24}>
        <CustomInfoCard
          title="BriteWin"
          paragraph={requestAlreadyExists ? `${PENDING_REQUEST}` : `${ACCESS_DENIED}`}
          divider
          button
          buttonLabel={requestAlreadyExists ? `${MADE_REQUEST}` : `${REQUEST_ACCESS}`}
          handleClick={() => handleRequestAccess(email, history, setRequestAlreadyExists)}
          disabled={requestAlreadyExists}
        />
      </Col>
    </Row>
  );
};

export default NoAccess;
